export const totalEntradas = (reportes) => {
  let total = 0;
  let cantidad = 0;
  let concurrencia = 0;
  let ausentes = 0;
  let descuentos = 0;

  reportes.data.map((re) => {

    let precio = parseFloat(re.cantidad * re.unidad);
    if(re.descuento > 0){
      descuentos = (precio/100*re.descuento) + descuentos;
      precio = precio - (precio/100*re.descuento)
    }

    total = precio + total;

    let reporteCantidad = parseInt(re.cantidad);
    if(re.multiplicador){
      reporteCantidad = reporteCantidad * re.multiplicador;
    }

    cantidad = reporteCantidad + cantidad;

    if (re.reporte_codigo.length > 0) {
      re.reporte_codigo.map((rc) => {
        if (rc.ingreso == "ESPERA") {
          ausentes += 1;
        }
        if (rc.ingreso == "CONCURRIO") {
          concurrencia += 1;
        }
      });
    } else {
      if (re.registro_cliente == "CONCURRIO") {
        concurrencia += 1;
      }

      if (re.registro_cliente == "ESPERA") {
        ausentes += 1;
      }
    }
  });

  return {
    total,
    cantidad,
    concurrencia,
    ausentes,
    descuentos
  };
};

export const tipoEntrada = (reportes) => {
  let tipoEntrada = [
    {label: 'TODOS', value: 'TODOS'}
  ];


  reportes.map((re) => {
   console.log(re);
    if (tipoEntrada.filter((te) => te.value == re.entrada?.id).length > 0) {
    } else {
      tipoEntrada.push(
       {label: re.entrada?.nombre, value: re.entrada?.id});
    }
  });

  return tipoEntrada;
};

// Procesar datos para gráfico de ventas por día
export const ventasPorDia = (reportes) => {
  const ventasPorFecha = {};

  reportes.data.forEach((re) => {
    const fecha = re.created_at.split('T')[0]; // Formato YYYY-MM-DD

    let precio = parseFloat(re.cantidad * re.unidad);
    if(re.descuento > 0){
      precio = precio - (precio/100*re.descuento);
    }

    if (!ventasPorFecha[fecha]) {
      ventasPorFecha[fecha] = {
        fecha: fecha,
        total: 0,
        cantidad: 0
      };
    }

    ventasPorFecha[fecha].total += precio;
    ventasPorFecha[fecha].cantidad += parseInt(re.cantidad);
  });

  // Convertir objeto a array y ordenar por fecha
  return Object.values(ventasPorFecha).sort((a, b) =>
    new Date(a.fecha) - new Date(b.fecha)
  );
};

// Procesar datos para gráfico de ventas por tipo de entrada
export const ventasPorTipoEntrada = (reportes) => {
  const ventasPorTipo = {};

  reportes.data.forEach((re) => {
    const tipo = re.entrada?.nombre || 'Sin categoría';

    let precio = parseFloat(re.cantidad * re.unidad);
    if(re.descuento > 0){
      precio = precio - (precio/100*re.descuento);
    }

    if (!ventasPorTipo[tipo]) {
      ventasPorTipo[tipo] = {
        name: tipo,
        value: 0,
        cantidad: 0
      };
    }

    ventasPorTipo[tipo].value += precio;
    ventasPorTipo[tipo].cantidad += parseInt(re.cantidad);
  });

  return Object.values(ventasPorTipo);
};

// Procesar datos para gráfico de ventas por fecha de función
export const ventasPorFechaFuncion = (reportes) => {
  const ventasPorFecha = {};

  reportes.data.forEach((re) => {
    const fecha = re.fecha; // Fecha de la función

    let precio = parseFloat(re.cantidad * re.unidad);
    if(re.descuento > 0){
      precio = precio - (precio/100*re.descuento);
    }

    if (!ventasPorFecha[fecha]) {
      ventasPorFecha[fecha] = {
        fecha: fecha,
        total: 0,
        cantidad: 0
      };
    }

    ventasPorFecha[fecha].total += precio;
    ventasPorFecha[fecha].cantidad += parseInt(re.cantidad);
  });

  return Object.values(ventasPorFecha);
};
